module.exports = __webpack_public_path__ + "static/parky-dd3c004f419b18ceea9ea55f41d552e5.png";